/* Carrito lateral: barra de envío que se llena con suavidad, el momento al llegar al envío gratis,
   «Completa tu ritual» en un toque y los momentos (abren el buscador con la búsqueda hecha).
   Marcado: snippets/cart-drawer-items.liquid · estilos: assets/fh-carrito.css.
   Nunca hace nada solo: todo pasa al abrir el carrito o al tocar algo. */
(function () {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastPct = null;      // lo que enseñaba la barra antes del último repintado
  var lastLines = null;    // enlaces de las líneas antes del repintado (para saber cuál es nueva)

  function ship() { return drawer.querySelector('[data-cd-ship]'); }
  function linesNow() {
    var s = {};
    drawer.querySelectorAll('.cd-line .cd-line__title').forEach(function (a) { s[a.getAttribute('href')] = 1; });
    return s;
  }
  // Lleva la barra de `from` a su valor (0–1000), con transición de transform
  function fill(from, celebrate) {
    var sh = ship(); if (!sh) { lastPct = 0; return; }
    var to = +sh.getAttribute('data-pct') || 0;
    var f = sh.querySelector('.cd-ship__fill');
    if (reduce || from === to || !f) { lastPct = to; return; }
    var doneNow = to >= 1000, doneBefore = from >= 1000 || !celebrate;
    if (doneNow && !doneBefore) sh.classList.remove('is-done'); // el texto cambia cuando la barra llega
    f.style.transition = 'none';
    f.style.transform = 'scaleX(' + (from / 1000) + ')';
    void f.offsetWidth;
    f.style.transition = '';
    requestAnimationFrame(function () {
      f.style.transform = 'scaleX(' + (to / 1000) + ')';
      if (doneNow && !doneBefore) {
        setTimeout(function () { sh.classList.add('is-done', 'is-arriving'); }, 650);
        setTimeout(function () { sh.classList.remove('is-arriving'); }, 2600);
      }
    });
    lastPct = to;
  }

  // Al abrir: la barra sale de 0 la primera vez, después desde donde estaba
  new MutationObserver(function () {
    if (drawer.classList.contains('is-open')) {
      if (!drawer._cdWasOpen) { drawer._cdWasOpen = true; fill(lastPct === null ? 0 : lastPct, false); }
    } else { drawer._cdWasOpen = false; }
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  // Al repintar (global.js cambia el innerHTML): la barra va del valor viejo al nuevo y la línea nueva entra suave
  new MutationObserver(function () {
    var prev = lastLines; lastLines = linesNow();
    if (prev) {
      drawer.querySelectorAll('.cd-line').forEach(function (l) {
        var a = l.querySelector('.cd-line__title');
        if (a && !prev[a.getAttribute('href')] && !reduce) l.classList.add('is-new');
      });
    }
    var from = lastPct === null ? 0 : lastPct;
    if (!drawer.classList.contains('is-open')) { var sh = ship(); lastPct = sh ? +sh.getAttribute('data-pct') : 0; return; }
    fill(from, true);
  }).observe(drawer, { childList: true });
  lastLines = linesNow();

  // «Completa tu ritual»: añadir sin salir del carrito (una sola petición: add.js ya devuelve el carrito repintado)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cd-add]'); if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-adding')) return;
    b.classList.add('is-adding');
    var t0 = Date.now();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.dataset.variantId, quantity: 1 }], sections: 'cart-drawer', sections_url: location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (data) {
        b.classList.remove('is-adding'); b.classList.add('is-added');
        var html = data && data.sections && data.sections['cart-drawer'];
        // que se vea el ✓ un instante antes de repintar
        setTimeout(function () {
          if (html && window.fhApplyCartHTML) window.fhApplyCartHTML(html);
          else if (window.fhRefreshCart) window.fhRefreshCart();
        }, Math.max(0, 520 - (Date.now() - t0)));
      })
      .catch(function () { b.classList.remove('is-adding'); });
  });

  // Momentos: abren el buscador con la búsqueda ya hecha (si no hay buscador en la página, el enlace va a /search)
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-fh-momento]'); if (!m) return;
    var modal = document.getElementById('SearchModal');
    var input = modal && modal.querySelector('[data-search-input]');
    if (!input) return;
    e.preventDefault();
    var q = m.getAttribute('data-fh-momento');
    if (!modal.classList.contains('is-open')) {
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' })); // cierra el carrito si está abierto
      var t = document.createElement('button'); t.type = 'button'; t.hidden = true;
      t.setAttribute('data-open', '#SearchModal'); document.body.appendChild(t); t.click(); t.remove();
    }
    input.value = q;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    if (window.fhSearchRecent) window.fhSearchRecent(q);
  });
})();
